import React from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import axios from "axios";

import MasterLedgerEditForm from "./MasterLedgreEditForm";
import formatZdate from "../../../utils/formatZdate";

const getIndustryOneAPI = `${process.env.REACT_APP_API_URL}api/ledger`;

const MasterLedgerEdit = ({
  buttonConfig,
  selectedItemId,
  renderKey,
  tableData,
  isButtonClicked
}) => {
  const schema = z.object({
    account_name: z.string().nonempty(),
    account_short_name: z.string().nonempty(),
    group_name: z.string().nonempty(),
    account_type: z.string().nonempty(),

    credit_debit: z.string(),
  });

  const headers = {
    Authorization: `Bearer ${sessionStorage.getItem("subscriberToken")
    ? sessionStorage.getItem("subscriberToken")
    : sessionStorage.getItem("token")}`,
    "Content-Type": "application/json",
  };

  const form = useForm({
    defaultValues: async () => {
      const getSegment = `${getIndustryOneAPI}/${selectedItemId}`;
      const res = await axios.get(getSegment, { headers });
      const segment = res.data.data;
      // console.log(segment);
      return {
        account_name: segment.account_name,
        account_short_name: segment.account_short_name,
        group_name: segment.group_name,
        account_type: segment.account_type,

        credit_debit: segment.credit_debit,
        status: "true",
      };
    },
    resolver: zodResolver(schema),
  });

  return (
    <MasterLedgerEditForm
      form={form}
      segmentName={buttonConfig.name}
      editHandler={buttonConfig.editHandler}
      closeHandler={buttonConfig.closeEditModal}
      selectedItemId={selectedItemId}
      tableData={tableData}
      isButtonClicked={isButtonClicked}
    />
  );
};

export default MasterLedgerEdit;
